import styles from './SphereLoadingScreen.module.css';

/** Shown by `next/dynamic`'s `loading` option while the SphereCanvas chunk loads. */
export const SphereLoadingScreen = () => (
  <div className={styles.wrap} aria-hidden="true">
    <div className={styles.dot} />
  </div>
);
